import * as Immutable from 'immutable';
import debug from '../../services/debug';

import {
  GET_DOCUMENTS_ADVISERS_ABORTED,
  GET_DOCUMENTS_ADVISERS_REQUESTED,
  GET_DOCUMENTS_ADVISERS_COMPLETED,
  GET_DOCUMENTS_ADVISERS_FAILED,
  DOWNLOAD_DOCUMENT_ADVISERS_REQUESTED,
  DOWNLOAD_DOCUMENT_ADVISERS_COMPLETED,
  DOWNLOAD_DOCUMENT_ADVISERS_FAILED,
  VIEW_DOCUMENT_ADVISERS_REQUESTED,
  VIEW_DOCUMENT_ADVISERS_COMPLETED,
  VIEW_DOCUMENT_ADVISERS_FAILED,
  RESET_VIEW_DOCUMENT_ADVISERS_REQUESTED,
  RESET_VIEW_DOCUMENT_ADVISERS_COMPLETED,
  RESET_VIEW_DOCUMENT_ADVISERS_FAILED,

  // RESET_DOCUMENTS_ADVISERS_REQUESTED,
  // RESET_DOCUMENTS_ADVISERS_COMPLETED,
} from '../../actions/documentsadvisers/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: { items: null },
  resettingdata: false,
  gettingdata: false,
  gotdata: false,

  downloadingdata: false,
  downloadeddata: false,
  documentfile: null,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DOCUMENTS_ADVISERS_ABORTED:
      debug('Aborting get documents');
      return state.set('error', null).set('gettingdata', false);

    case GET_DOCUMENTS_ADVISERS_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case GET_DOCUMENTS_ADVISERS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_DOCUMENTS_ADVISERS_FAILED:
      // Clear the loading flag too, or the page spins forever instead of
      // showing the error (e.g. SharePoint unavailable).
      return state
        .set('gettingdata', false)
        .set('gotdata', false)
        .set('error', action.payload);

    case DOWNLOAD_DOCUMENT_ADVISERS_REQUESTED:
      return state
        .set('error', null)
        .set('downloadingdata', true)
        .set('data', action.payload);

    case DOWNLOAD_DOCUMENT_ADVISERS_COMPLETED:
      return state
        .set('error', null)
        .set('downloadingdata', false)
        .set('downloadeddata', true)
        .set('data', action.payload);

    case DOWNLOAD_DOCUMENT_ADVISERS_FAILED:
      return state.set('error', action.payload);

    case VIEW_DOCUMENT_ADVISERS_REQUESTED:
      return state
        .set('error', null)
        .set('downloadingdata', true)
        .set('documentfile', null)
        .set('data', action.payload);

    case VIEW_DOCUMENT_ADVISERS_COMPLETED:
      return state
        .set('error', null)
        .set('downloadingdata', false)
        .set('downloadeddata', false)
        .set('documentfile', action.payload.file)
        .set('data', action.payload.data);

    case VIEW_DOCUMENT_ADVISERS_FAILED:
      return state
        .set('error', action.payload)
        .set('documentfile', null)
        .set('error', action.payload.error);

    case RESET_VIEW_DOCUMENT_ADVISERS_REQUESTED:
      return state.set('error', null).set('downloadingdata', true);

    case RESET_VIEW_DOCUMENT_ADVISERS_COMPLETED:
      return state
        .set('error', null)
        .set('downloadingdata', false)
        .set('downloadeddata', true)
        .set('documentfile', null);

    case RESET_VIEW_DOCUMENT_ADVISERS_FAILED:
      return state.set('error', action.payload);

    // case RESET_DOCUMENTS_ADVISERS_REQUESTED:
    //     return state
    //         .set('error', null)
    //         .set('resettingdata', true);

    // case RESET_DOCUMENTS_ADVISERS_COMPLETED:
    //     return state
    //         .set('error', null)
    //         .set('data', { items: [] })
    //         .set('gettingdata', false)
    //         .set('gotdata', false)
    //         .set('downloadingdata', false)
    //         .set('downloadeddata', false)
    //         .set('resettingdata', false);
    default:
      return state;
  }
};

export { initialState };

export default reducer;
